import { makeStyles } from '@mui/styles';
import StatusLabel from './StatusLabel';

import { UnifiedReferralModel } from '../models/UnifiedReferralModel';
import type { ReferralParticipant } from '../models/UnifiedReferralModel';

import { formatDate } from 'util/index';

const useStyles = makeStyles(() => ({
    arrow: {
        display: 'flex',
        alignItems: 'center',
        alignSelf: 'center',
        justifyContent: 'center',
        backgroundColor: '#E7EFFE',
        borderRadius: '100%',
        color: '#062D7A',
        height: '32px',
        margin: '0 64px',
        minHeight: '32px',
        minWidth: '32px',
        width: '32px',
        '@media (max-width: 768px)': {
            margin: '0 32px'
        }
    },
    dateContainer: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    date: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        color: '#5A6A81',
        fontSize: '14px'
    },
    fromTo: {
        fontWeight: 300,
        fontSize: '16px',
        color: '#1F2152'
    },
    referralContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
    },
    referralInfoContainer: {
        display: 'flex'
    },
    referralInfo: {
        display: 'flex',
        flexDirection: 'column',
        flex: '1',
        gap: '8px'
    },
    referralNameOrg: {
        fontWeight: 600,
        fontSize: '24px',
        color: '#1F2152'
    },
    referralSubOrg: {
        color: '#5A6A81',
        fontSize: '18px',
        fontWeight: 400
    },
    nameOrgContainer: {
        display: 'flex',
        flexDirection: 'column'
    }
}));

type ReferralInfoProps = {
    referral: UnifiedReferralModel;
};

const ReferralParticipantInfo: React.FC<{ participant: ReferralParticipant }> = ({ participant }) => {
    const classes = useStyles();

    if (participant.type === 'organization') {
        return (
            <span className={classes.referralNameOrg}>
                {participant.name}
            </span>
        );
    }

    return (
        <div className={classes.nameOrgContainer}>
            <span className={classes.referralNameOrg}>
                {participant.name}
            </span>
            <span className={classes.referralSubOrg}>
                {participant.subtext}
            </span>
        </div>
    );
};

const ReferralInfo: React.FC<ReferralInfoProps> = ({
    referral
}) => {
    const classes = useStyles();

    const {
        referrer,
        referee,
        created_at,
        statusText
    } = referral;

    return (
        <div className={classes.referralContainer}>
            <div className={classes.referralInfoContainer}>
                <div className={classes.referralInfo}>
                    <span className={classes.fromTo}>From</span>
                    <ReferralParticipantInfo participant={referrer} />
                </div>
                <div className={classes.arrow}>
                    <i className="fas fa-arrow-right" />
                </div>
                <div className={classes.referralInfo}>
                    <span className={classes.fromTo}>To</span>
                    {referee && <ReferralParticipantInfo participant={referee} />}
                </div>
            </div>
            <div className={classes.dateContainer}>
                <span className={classes.date}>
                    <i className="far fa-calendar-alt" />
                    Created on: {formatDate(created_at)}
                </span>
                <StatusLabel status={statusText} />
            </div>
        </div>
    );
};

export default ReferralInfo;
